<cb-dialog class="flex-col"
           dialogHeading="Download Multiple Documents"
           [canClose]="!downloading">
    <cb-table [loaded]="loaded"
              maxHeightOffset="310">
        <thead cbTableHead>
        <tr>
            <td></td>
            @for (extraColumn of data.prefixColumns; track extraColumn) {
                <td>{{ extraColumn.label }}</td>
            }
            <td>Name</td>
            <td>Type</td>
        </tr>
        </thead>
        <tbody cbTableBody>
            @for (element of downloadableDocuments; track element) {
                <tr
                    class="overflow-hidden">
                    <td class="overflow-hidden">
                        @if (!downloading && !successful[element.id] && !failed[element.id]) {
                            <mat-icon class="cb-grey"
                                      matTooltip="Download not started">radio_button_unchecked
                            </mat-icon>
                        }
                        @if (downloading && !successful[element.id] && !failed[element.id]) {
                            <mat-spinner
                                diameter="20"
                                matTooltip="Download in progress"></mat-spinner>
                        }
                        @if (successful[element.id]) {
                            <mat-icon
                                color="primary"
                                matTooltip="Download Succeded">check_circle
                            </mat-icon>
                        }
                        @if (failed[element.id]) {
                            <mat-icon
                                class="cb-error"
                                [matTooltip]="failed[element.id]">cancel
                            </mat-icon>
                        }
                    </td>
                    @for (extraColumn of data.prefixColumns; track extraColumn) {
                        <td
                            class="overflow-hidden">
                            <dl>
                                @for (prop of extraColumn.props; track prop) {
                                    <dd class="mat-body-2"
                                    >{{ element[prop] }}
                                    </dd>
                                }
                            </dl>
                        </td>
                    }
                    <td class="overflow-hidden">
                        @if (element.document.isLinkedDocument) {
                            <cb-info-popup
                                [icon]="'linked'"
                                [tooltip]="'This is a Linked Document'">
                            </cb-info-popup>
                        }
                        @if (element.document) {
                            <cb-info-popup
                                [label]="element.document.name"
                                [tooltip]="element.document.description">
                            </cb-info-popup>
                        }
                    </td>
                    <td class="overflow-hidden">
                        <cb-info-popup [label]="element.documentType.label"
                                       [tooltip]="element.documentType.description">
                        </cb-info-popup>
                    </td>
                </tr>
            }
        </tbody>
    </cb-table>
    <div actions>
        <form #form="ngForm"
              class="cb-margin-right flex-col flex">
            <cb-input class="flex"
                      label="Zip File Name"
                      name="zipFileName"
                      [(ngModel)]="zipFileName"
                      [required]="true"></cb-input>
        </form>
        <button mat-raised-button
                color="primary"
                (cbClick)="download()"
                [throttleTime]="2000"
                [disabled]="form.invalid || downloading">Download
        </button>
        <button mat-raised-button
                [disabled]="downloading"
                (click)="cancel()">Close
        </button>
    </div>
</cb-dialog>
